import * as d from "../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
const {
  vec2: t,
  uv: i,
  viewportSize: u
} = d, x = (e = t(0, 0)) => {
  const r = u, o = r.x.div(r.y), c = i(), n = t(0.5, 0.5), s = t(c.x.add(e.x), c.y.add(e.y));
  return {
    correctedUV: t(s.x.mul(o), s.y),
    correctedCenter: t(n.x.mul(o), n.y)
  };
};
export {
  x as getAspectCorrectedCoordinates
};
